export default __webpack_public_path__ + "static/media/toggleIcon.631b8379.png";